import React from 'react'
import './markets.scss';
const Markets = () => {
    return (
        <>
            <section className='focus_main'>
                <div className='inner_focvus'>
                    <div className='custom-container'>
                        <div className='innar_last'>
                            <h2>Works in All Markets</h2>
                            <div>
                                <div className='left_inner'>
                                    <img src='\assets\puzz.svg' />
                                    <div>
                                        <h3>Bull Market</h3>
                                        <p>In a rising market, all tiers of our portfolio are positioned to capture upside.</p>
                                    </div>
                                </div>
                                <div className='left_inner'>
                                    <img src='\assets\wall.svg' />
                                    <div>
                                        <h3>Bear Market</h3>
                                        <p>This is where our defensive strategy provides the most value.
</p>
                                    </div>
                                </div>
                                <div className='left_inner'>
                                    <img src='\assets\shie.svg' />
                                    <div>
                                        <h3>Sideways Market</h3>
                                        <p>In a flat or choppy market, the fundamental strength of the exchange business model becomes our key advantage.</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    )
}

export default Markets
